/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Tag, Button, Space } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CreateEditEducatorModal from "./CreateEditModal";
import LectureFeedbackModal from "./LectureFeedbackModal";
import { showErrorNotification, showSuccessNotification } from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";

const CourseEducatorManagementDash = ({ adminConfig, ROOT_URL }) => {
  const [isCreateEditEducatorModalOpen, setIsCreateEditEducatorModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [courseEducatorList, setCourseEducatorList] = useState([]);
  const [educatorId, setEducatorId] = useState();
  const [isEducatorLectureAnalyticsModalOpen, setIsEducatorLectureAnalyticsModalOpen] =
    useState(false);
  const [coursesList, setCoursesList] = useState([]);
  const [batchesList, setBatchesList] = useState([]);

  const fetchCourseEducatorList = () => {
    axios
      .get(`${ROOT_URL}/admin/course-educator/list`, {})
      .then((res) => {
        const { courseEducators } = res.data;
        setCourseEducatorList(courseEducators);
        showSuccessNotification("Educators fetched successfully!");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchFilterPreRequisites = () => {
    axios
      .get(`${ROOT_URL}/admin/course-educator/lecture-feedbacks/fetch-filter-pre-requisites`)
      .then(({ data }) => {
        const { coursesList, batchesList } = data;
        setCoursesList(coursesList);
        batchesList.push({ label: "All Batches", value: "" });
        setBatchesList(batchesList);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };
  const handleCreateEditEducator = (values) => {
    if (initialValues?.email !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/course-educator/update`, { _id: educatorId, ...values })
        .then(() => {
          setInitialValues({});
          showSuccessNotification("Educator updated Successfully");
          fetchCourseEducatorList();
          setIsCreateEditEducatorModalOpen(false);
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/course-educator/create`, { ...values })
        .then(() => {
          showSuccessNotification("Educator created Successfully");
          fetchCourseEducatorList();
          setIsCreateEditEducatorModalOpen(false);
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const handleCourseEducatorActivate = (key, active) => {
    axios
      .post(`${ROOT_URL}/admin/course-educator/update`, { _id: key, isActive: !active })
      .then(() => {
        showSuccessNotification(`Educator ${active ? "De-Activated" : "Activated"} Successfully`);
        fetchCourseEducatorList();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleDeleteCourseEducator = (courseEducatorId) => {
    axios
      .post(`${ROOT_URL}/admin/course-educator/delete`, {
        courseEducatorId
      })
      .then(() => {
        showSuccessNotification("Educator Deleted Successfully");
        fetchCourseEducatorList();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Contact Number",
      dataIndex: "contactNumber",
      key: "contactNumber"
    },
    {
      title: "Status",
      key: "active",
      dataIndex: "active",
      render: (active) => {
        const color = !active ? "red" : "green";
        return (
          <Tag color={color} key={active ? "Active" : "De-Activated"}>
            {!active ? "De-Activated" : "Active"}
          </Tag>
        );
      }
    },
    {
      title: "Actions",
      key: "action",
      width: 50,

      render: (row) => (
        <div
          id="admin_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                danger
                disabled={!adminConfig?.courseEducator?.hasManageAccess}
                type="primary"
                onClick={() => {
                  handleDeleteCourseEducator(row.key);
                }}
              >
                {row.deleted ? "Undo" : "Delete"}
              </Button>
              <Button
                disabled={!adminConfig?.courseEducator?.hasManageAccess}
                type="primary"
                onClick={() => {
                  handleCourseEducatorActivate(row.key, row.active);
                }}
              >
                {row.active ? "De-Activate" : "Activate"}
              </Button>
              <Button
                type="primary"
                disabled={!adminConfig?.courseEducator?.hasManageAccess}
                onClick={() => {
                  setInitialValues(row);
                  setEducatorId(row.key);
                  setIsCreateEditEducatorModalOpen(true);
                }}
              >
                Modify Details
              </Button>
              {adminConfig?.courseEducator?.hasFeedbackViewAccess && (
                <Button
                  disabled={!adminConfig?.courseEducator?.hasFeedbackViewAccess}
                  type="primary"
                  onClick={() => {
                    setEducatorId(row.key);
                    setIsEducatorLectureAnalyticsModalOpen(true);
                  }}
                >
                  Lecture Feedbacks
                </Button>
              )}
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchCourseEducatorList();
    fetchFilterPreRequisites();
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px"
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateEditEducatorModalOpen(true);
          }}
        >
          Create Educator
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={courseEducatorList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isCreateEditEducatorModalOpen === true && (
        <CreateEditEducatorModal
          isModalOpen={isCreateEditEducatorModalOpen}
          setIsModalOpen={setIsCreateEditEducatorModalOpen}
          initialValues={initialValues}
          isEdit={initialValues?.email !== undefined}
          handleCreateEdit={handleCreateEditEducator}
        />
      )}
      {isEducatorLectureAnalyticsModalOpen === true && (
        <LectureFeedbackModal
          isModalOpen={isEducatorLectureAnalyticsModalOpen}
          setIsModalOpen={setIsEducatorLectureAnalyticsModalOpen}
          batchList={batchesList}
          currentEducatorId={educatorId}
          ROOT_URL={ROOT_URL}
          coursesList={coursesList}
        />
      )}
    </div>
  );
};

export default CourseEducatorManagementDash;
